export const ERROR_CODES = {
  EC_COMPANY_ID_MISMATCH: '3AF17B1D-98C0-4C60-B8A5-F1825D2E1D9C',
  EC_USER_NOT_FOUND: '7E0EC3B4-CC84-42C3-9857-18AD5F7B8E6E',
  EC_INVALID_QR_CODE: '947CDF44-07AC-447A-977A-DE535E17549C',
  EC_CHECKIN_COOLDOWN_NOT_EXPIRED: '8F39EE27-3973-41DB-BD74-0AD2E079AD65',
  EC_CHECKIN_LIMIT_REACHED: '4C5D9953-76E3-422B-975E-0D5E0EA88D2B',
} as const;

export const ERROR_MESSAGES: Record<string, string> = {
  [ERROR_CODES.EC_COMPANY_ID_MISMATCH]: 'User is from a different company',
  [ERROR_CODES.EC_USER_NOT_FOUND]: 'User not found',
  [ERROR_CODES.EC_INVALID_QR_CODE]: 'Invalid QR code',
  [ERROR_CODES.EC_CHECKIN_COOLDOWN_NOT_EXPIRED]: 'Check-in cooldown not expired',
  [ERROR_CODES.EC_CHECKIN_LIMIT_REACHED]: 'Check-in limit reached',
};